<template>
  <main class="wrapper-content">
    <h1>{{ $t('reviewer_groups') }}</h1>
    <b-row v-if="!isLoading">
      <LmTextInput
        class="col-md-6 col-12"
        placeholder="Nombre"
        label="Nombre"
        v-model="$v.name.$model"
        :v="v('name')"
      />
      <LmTextInput
        class="col-md-6 col-12"
        placeholder="Alias"
        label="Alias"
        v-model="$v.alias.$model"
        :v="v('alias')"
      />
      <b-col md="12" class="mb-4">
        <div>
          <h3>{{ $t('reviewer_that_make_up_the_group') }}</h3>
          <div class="d-flex flex-wrap mb-3" style="gap: 1rem" v-if="users.length">
            <span
              class="p-2 border rounded-lg d-flex align-items-center justify-content-between"
              style="gap: 1rem"
              v-for="(item, index) in users"
              :key="index"
            >
              <b-avatar variant="primary" :text="item.userInitials" :src="item.avatar"></b-avatar>
              <span>{{ item.name }}</span>
              <span @click="onRemove(index)">
                <i class="mdi mdi-close-circle-outline clickable" style="font-size: 1.3rem"></i>
              </span>
            </span>
          </div>
          <div v-else>
            <p>{{ $t('add_reviewers_to_be_able_to_create_a_new_group') }}</p>
          </div>
          <LmButton
            buttonClass="btn-info"
            value="Agregar Usuarios"
            @click="$bvModal.show('users-datatable-modal')"
          />
        </div>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col><b-skeleton type="input"></b-skeleton></b-col>
      <b-col><b-skeleton type="input"></b-skeleton></b-col>
      <b-col md="12" class="my-4">
        <div>
          <div class="d-flex flex-wrap mb-3" style="gap: 1rem" v-if="users.length">
            <span
              class="p-2 border rounded-lg d-flex align-items-center justify-content-between"
              style="gap: 1rem"
              v-for="(item, index) in 4"
              :key="index"
            >
              <b-skeleton type="avatar"></b-skeleton>
              <b-skeleton width="100px"></b-skeleton>
            </span>
          </div>
          <b-skeleton type="button" width="150px"></b-skeleton>
        </div>
      </b-col>
    </b-row>
    <b-modal
      id="users-datatable-modal"
      size="xl"
      @ok="onConfirmUsers"
      :cancel-title="$t('cancel')"
      :ok-title="$t('confirm')"
    >
      <LmDataTable
        @onSelect="onSelectUsers"
        slug="usuarios-todos-grupos-modal"
        hideButtons
      />
    </b-modal>
    <div class="buttons">
      <LmButton
        buttonClass="btn-secondary"
        :value="$t('go_back')"
        @click="onCancel"
        :isProcessing="isProcessing"
      />
      <LmButton
        buttonClass="btn-primary"
        :value="$t('save')"
        :disabled="!users.length"
        @click="onSubmit"
        :isProcessing="isProcessing"
      />
      <LmButton
        v-if="isOnEditMode && !deleted"
        :requireConfirmation="true"
        :confirmationTitle="$t('you_are_about_to_delete_the_reviewer_group')"
        buttonClass="btn-danger"
        :value="$t('delete')"
        @click="onDelete"
        :isProcessing="isProcessing"
      />
      <LmButton
        v-if="isOnEditMode && deleted"
        value="Reactivar"
        :requireConfirmation="true"
        :confirmationTitle="$t('you_are_about_to_reactivate_the_reviewer_group')"
        buttonClass="btn-success"
        @click="onReactivate()"
        :isProcessing="isProcessing"
      />
    </div>
  </main>
</template>

<script>
// Components
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmButton from '@/components/form/elements/LmButton'
import LmDataTable from '@/components/lmDataTable/table'

// Utils
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts'
import _ from 'lodash'
import { required } from 'vuelidate/lib/validators'

export default {
  mixins: [lmToasts],
  components: {
    LmTextInput,
    LmButton,
    LmTreeSelect,
    LmDataTable
  },
  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    isOnModal: {
      type: Boolean,
      default: false
    },
    editItemId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isLoading: false,
      name: '',
      alias: '',
      deleted: false,
      users: [],
      usersToAdd: [],
      instancePases: {
        area: [],
        user: []
      },
      isProcessing: false
    }
  },
  validations: {
    name: { required },
    alias: { required }
  },
  computed: {
    itemId () {
      return this.editItemId ? this.editItemId : this.$route.params.id
    }
  },
  methods: {
    v (position) {
      return _.get(_.cloneDeep(this.$v), position)
    },
    validateForm (validation) {
      validation.$touch()
      if (validation.$error) {
        this.lmToastDangerMessage(this.$t('form_with_errors'), 'Error')
        throw new Error('validation error')
      } else {
        if (validation.$pending || validation.$error) {
          throw new Error('validation error')
        }
      }
    },
    async onSubmit () {
      try {
        await this.validateForm(this.$v)
        this.isProcessing = true
        if (this.isOnEditMode) {
          await commonsApi.axiosPutWrapper(`/reviewersgroups/${this.itemId}`, {
            name: this.name,
            alias: this.alias,
            users: this.users,
            pases: this.instancePases
          })
          if (this.isOnModal) {
            this.$emit('itemUpdated')
          }
        } else {
          const res = await commonsApi.axiosPostWrapper('/reviewersgroups', {
            name: this.name,
            alias: this.alias,
            users: this.users,
            pases: this.instancePases
          })
          this.$router.replace(`/revisores/editar/${res.data._id}`)
        }
        this.lmToastSuccessMessage(
          `${this.$t('reviewer_group_saved_successfully')} ${this.name}`,
          `${this.$t('action_done_successfully')}`
        )
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    onCancel () {
      if (this.isOnModal) {
        this.$emit('closeModal')
      } else {
        this.$router.go(-1)
      }
    },
    async onDelete () {
      try {
        this.isProcessing = true
        await commonsApi.axiosDeleteWrapper(`/reviewersgroups/delete/${this.itemId}`)
        this.lmToastSuccessMessage(
          `${this.$t('reviewer_group_was_successfully_deleted')} ${this.name}`,
          `${this.$t('action_done_successfully')}`
        )
        this.onCancel()
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    async onReactivate () {
      try {
        this.isProcessing = true
        await commonsApi.axiosPutWrapper(`/reviewersgroups/reactivate/${this.$route?.params?.id}`)
        this.lmToastSuccessMessage(`${this.$t('the_reviewer_group_was_successfully_reactivated')}`, `${this.$t('it_was_successfully_reactivated')}`)
        this.onCancel()
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    onRemove (index) {
      this.users.splice(index, 1)
    },
    async onSelectUsers (event) {
      let users = _.cloneDeep(this.users)

      for (const item of event) {
        const user = await this.loadUserInfo(item.id)
        users.push(user)
      }

      users = users.flat()

      this.usersToAdd = [...new Map(users.map(item => [item.id, item])).values()]
    },
    onConfirmUsers () {
      this.users = this.usersToAdd
      this.usersToAdd = []
    },
    async loadUserInfo (id) {
      const res = await commonsApi.axiosGetWrapper(`/users/user-meta/${id}`)
      return {
        id: res.data.id,
        name: `${res.data.firstname} ${res.data.lastname}`,
        userInitials: res.data?.userInitials,
        avatar: res.data?.profilePicture || ''
      }
    },
    async loadData () {
      const res = await commonsApi.axiosGetWrapper(`/reviewersgroups/${this.itemId}`)
      this.name = res.data.name
      this.alias = res.data.alias
      this.deleted = res.data.deleted
      // Chequea si existe pases por retrocompatibilidad
      if (res.data.pases) {
        this.instancePases = res.data.pases
      }
      const promises = []
      for (const item of res.data.users) {
        const promise = this.loadUserInfo(item._id)
        promises.push(promise)
      }
      this.users = await Promise.all(promises)
    }
  },
  async created () {
    try {
      this.isLoading = true
      if (this.isOnEditMode) {
        await this.loadData()
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>
